/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */
import axios from 'axios';
import globalConfig from '../config'

const GET_LANGUAGE_TYPE = '/get/i18n_type'
const GET_I18N = '/static/i18n/'
const GET_HEADER_LIST = '/headerList'
const PERMISSION_CHECK = '/permissionCheck'

const init = function () {
  // alert(window.access)
  axios.interceptors.request.use(function (config) {
    if (config.url.indexOf(GET_LANGUAGE_TYPE) < 0 &&
      config.url.indexOf(GET_HEADER_LIST) < 0 &&
      config.url.indexOf(GET_I18N) < 0 &&
      config.url.indexOf(PERMISSION_CHECK) < 0) {
      config.url = window.localStorage.gatewayDomain + config.url
    }
    var cookies = globalConfig.getCookies()
    if (config.url.indexOf(GET_LANGUAGE_TYPE) < 0 &&
      config.url.indexOf(GET_HEADER_LIST) < 0 &&
      config.url.indexOf(GET_I18N) < 0) {
      config.url += ('access_token=' + cookies['access_token'])
      // config.url += ('access_token=' + window.access)
      // config.url += ('access_token=0769175f-3408-4e38-bc28-0b6802241111')
      // config.url += ('access_token=56766986-b522-4de7-b2c5-516f460b61ca')
    }
    if (!config.data) config.data = {}
    return config;
  }, function (err) {
    // return Promise.reject(err)
    return (err)
  })
  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    const {status, data} = response;
    if (status === 200) {
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.code === 'success') {
        return data
      } else {
        return data
      }
    } else {
      return response;
    }
  }, function (error) {
    const {response} = error;

    // 这里处理错误的 http code
    if (response.status === 404) {
      console.log('404 error %o' + error);
    }

    // Do something with response error
    return Promise.reject(error);
  });
};

export default {
  init
}



// WEBPACK FOOTER //
// ./src/services/ajax.js